import axios from "axios"
import api from "@/store/api";
import router from "@/router";

export const state = {
  data: { year: '', month: '', week: ''},
  selectedAppointment: {},
  searchResults: [],
  loading: false,
  allDays: [],
}

export const mutations = {
  SET_PROGRAMARI (state, data) {
    state.data = data
  },
  SET_ALL_DAYS (state, days) {
    state.allDays = days
  },
  SET_SELECTED_APPOINTMENT (state, data) {
    state.selectedAppointment = JSON.parse(JSON.stringify(data));
  },
  SET_SELECTED_APPOINTMENT_FIELD (state, {key, value}) {
    state.selectedAppointment[key] = value;
  },
  UPDATE_EDITED_APPOINTMENT(state, updatedItem) {
    const newDays = [...state.data.days];
    let removeItem = +state.data.month !== +updatedItem.month;
    let movedItem = null;

    // Find and remove item from its current day
    newDays.forEach(day => {
      const index = day.items.findIndex(item => item.id === updatedItem.id);
      if (index > -1) {
        if (removeItem) {
          day.items = day.items.filter(item => item.id !== updatedItem.id);
        } else {
          movedItem = { ...updatedItem };
          day.items = day.items.filter(item => item.id !== updatedItem.id);
        }
      }
    });

    // If item was moved to a new day in the same month
    if (movedItem) {
      let targetDay = newDays.find(day => day.date === updatedItem.day);
      if (!targetDay) {
        targetDay = {
          date: updatedItem.day,
          day: updatedItem.day,
          items: []
        };
        newDays.push(targetDay);
      }
      targetDay.items = [...targetDay.items, movedItem];
    }

    // Filter empty days and sort by date
    state.data.days = newDays
      .filter(day => day.items.length > 0)
      .sort((a, b) => a.date - b.date);
    console.log(state.data.days)
  },
  REMOVE_BOOKING (state, targetId) {
    // Loop through days
    for (let dayIndex = 0; dayIndex < state.data.days.length; dayIndex++) {
      const day = state.data.days[dayIndex];

      // Loop through items in each day
      const itemIndex = day.items.findIndex(item => item.id === targetId);

      if (itemIndex !== -1) {
        // Remove the item
        day.items.splice(itemIndex, 1);

        // If day has no more items, remove the day
        if (day.items.length === 0) {
          state.data.days.splice(dayIndex, 1);
        }

        return true; // Item found and removed
      }
    }

    return false; // Item not found
  },
  SET_SEARCH_RESULTS (state, data) {
    state.searchResults = data
  },
  SET_LOADING (state, value) {
     state.loading = value
  }
}

export const actions = {
  async create_programare ({ commit }, payload) {
    try {
      const { data } = await axios.post(api.programari, payload);
      commit('SET_PROGRAMARI', data);
      await router.push('/programari');
    } catch (err) {
      console.log(`ERROR get programari`)
    }
  },
  async fetch_programari ({ commit }, query = '') {
    try {
      commit('SET_PROGRAMARI', {});
      commit('SET_ALL_DAYS', []);

      const params = new URLSearchParams(query.replace('?', ''));
      const month = params.has('month') ? +params.get('month') : new Date().getMonth();
      const year = params.has('year') ? +params.get('year') : new Date().getFullYear();

      const prevMonth = month === 0 ? 11 : month - 1;
      const prevYear = month === 0 ? year - 1 : year;
      const nextMonth = month === 11 ? 0 : month + 1;
      const nextYear = month === 11 ? year + 1 : year;

      const [current, prev, next] = await Promise.all([
        axios.get(`${api.programari}?month=${month}&year=${year}`),
        axios.get(`${api.programari}?month=${prevMonth}&year=${prevYear}`),
        axios.get(`${api.programari}?month=${nextMonth}&year=${nextYear}`),
      ]);

      commit('SET_PROGRAMARI', current.data);

      const allDays = [
        ...(prev.data.days || []).map(d => ({ ...d, month: prevMonth })),
        ...(current.data.days || []).map(d => ({ ...d, month })),
        ...(next.data.days || []).map(d => ({ ...d, month: nextMonth })),
      ];
      commit('SET_ALL_DAYS', allDays);

    } catch (err) {
      console.log(`ERROR get programari`)
    }
  },
  async update_appointment ({ state, commit }, item) {
    try {
      const url = `${api.programari}/${item.id}`;
      const { data } = await axios.put(url, state.selectedAppointment);
      commit('SET_MODAL', false);
      // todo create a mutation to find and update the specific edited object details
      // commit('SET_PROGRAMARI', data);
      commit('UPDATE_EDITED_APPOINTMENT', data);
    } catch (err) {
      console.log(`ERROR update appointment`)
    }
  },
  async delete_appointment ({ commit }, id) {
    try {
      const url = `${api.programari}/${id}`;
      await axios.delete(url);
      commit('REMOVE_BOOKING', id);
      commit('SET_MODAL', false);
    } catch (err) {
      console.log(`ERROR delete appointment`)
    }
  },
  async search_programari ({ commit }, query) {
    try {
      commit('SET_LOADING', true)
      const { data } = await axios.get(`${api.programari}/search?q=${query}`);

      const months = [
        "Ian.", "Feb.", "Mart.", "Apr.", "Mai", "Iun.",
        "Iul.", "Aug.", "Sept.", "Oct.", "Nov.", "Dec."
      ];

      const formatted = data.map(item => ({
        ...item,
        date: `${item.day} ${months[item.month - 1]} ${item.year}`
      }));

      commit('SET_SEARCH_RESULTS', formatted);
    } catch (err) {
      console.log(`ERROR search programari`, err.message)
    } finally {
      setTimeout(() => {
        commit('SET_LOADING', false)
      }, 1000)
    }
  }
}

export const getters = {
  appointmentsByDate: state => {
    return state.allDays.reduce((acc, day) => {
      acc[`${day.month}-${day.date}`] = day.items;
      return acc;
    }, {});
  }
}